import firebase from 'firebase/app';
import "firebase/auth";
import "firebase/database"
import "firebase/analytics"

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID
};

firebase.initializeApp(firebaseConfig);

var auth_obj = firebase.auth();
if (process.env.REACT_APP_PUBLIC_URL === "http://localhost:5000") {
    console.log("useEmulator:auth")
    auth_obj.useEmulator("http://localhost:9099/")
}

var database_obj = firebase.database();

export const auth = auth_obj;
export const db = database_obj;
export default firebase;